<template>
  <NsiCard :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :listName="listName" />
</template>

<script>
  import NsiCard from '../components/NsiCard.vue';

  export default {
    name: 'NsiCountryCoverageCard',
    components: {
      NsiCard,
    },
    data() {
      return {
        pageTitle: 'Карточка страновой охват',
        apiRoute: 'nsiCountryCoverage',
        cardName: 'NsiCountryCoverageCard',
        listName: 'NsiCountryCoverage',
      };
    },
    created() {},
    methods: {},
  };
</script>
